import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
const Work = () => {
    return (
        <>
            <Container fluid style={{maxWidth: "1900px"}}>
				<Row>
					<Col sm={{span: 10, offset: 2}}>
						<h2>Work.</h2>
					</Col>
				</Row>
				<Row>
					<Col
						xs={{span: 11, offset: 0}}
						sm={{span: 4, offset: 2}}
						style={{marginRight: "1%", marginBottom: "5%"}}
						className="d-flex justify-content-center"
					>
						<div>
							<a href="https://mayflowermgt.com/">
								<div className="tint-overlay hover-underline-animation">
									<h3 style={{padding: "5px"}}>Mayflower Building Services</h3>
								</div>
							</a>

							<img
								className="image-grid"
								src="./Images/mfg-website.png"
								alt="mayflower website"
							/>
						</div>
					</Col>
					<Col
						xs={{span: 11, offset: 0}}
						sm={{span: 4, offset: 0}}
						style={{marginRight: "1%", marginBottom: "5%"}}
						className="d-flex justify-content-center"
					>
						<a href="https://bornchinese.ca/">
							<div className="tint-overlay hover-underline-animation">
								<h3>Born Chinese</h3>
							</div>
						</a>
						<img
							className="image-grid"
							src="./Images/bc-website.png"
							alt="mayflower website"
						/>
					</Col>
				</Row>
			</Container>
        </>
    )
}

export default Work
